<template>
    <div class="franchise">
        <!-- <p class="title">加盟介绍</p> -->
        <el-row type="flex" class="row-bg main" justify="center">
            <el-col :span="20">
                <div class="content">
                    <!-- <p>加盟优势</p>
                    <span class="yellow"></span>
                    <p>1,企业优势</p>
                    <p>壹米滴答提供高水准门到门快运服务。采用标准定价、标准操作流程，各环节均以较快速度进行发运、中转、派送，并对客户进行相对标准承诺的快运产品。</p>
                    <p>2,行业优势</p>
                    <p> 1 ) 物流行业经过短时间内的快速崛起，其主要原因为国家政策的扶持和支持；中国电子商务市场，消费者行为习惯的变革推动了整个市场快速发展；同时，快运独特的行业状况和商业模式，引领公司、合作伙伴、顾客认知共同前进。最终实现顾客价值和销售目标。从而推动行业的快速发展和变革!</p>
                    <p> 2 ) 然而当前行业前10名的整体份额小于5%，相对于美国行业前10名占行业60%，这个行业还处在早期阶段。</p>
                    <p> 3 ) 这是一个变革的时代。我们应当庆幸，庆幸的是身处变革时代谁都有机会。</p>
                    <p>加盟条件</p>
                    <span class="yellow"></span>
                    <p>1,认同壹米滴答发展的理念，有相同的发展愿景；</p>
                    <p>2,具备揽货能力及基本配送能力；</p>
                    <p>3,统一使用信息系统、资金账户、统一网点经营、统一品牌形象；</p>
                    <p>4,接受壹米滴答业务量考核，严格执行运营标准，并接受管控考核；</p>
                    <p>5,缴纳一定的押金、系统使用费等费用</p>
                    <p>加盟政策扶持</p>
                    <span class="yellow"></span>
                    <p>1,一对一帮扶</p>
                    <p>开业后，由片区网管/直营门店经理对新开网点进行现场指导操作，并针对出现问题及时协助解决。</p>
                    <p>2,罚款减免</p>
                    <p>新开加盟网点享有半个月罚款减免期，即从新开网点第一次开单/到达之日起开始计算顺延15天做为罚款减免期，遗失、破损、短少、违禁品除外。</p>
                    <p>3,系统支持</p>
                    <p>加盟网点享有公司系统的使用权以及IT支持等。</p>
                    <p>加盟流程</p>
                    <span class="yellow"></span>
                    <p class="step"><span>提交加盟申请</span> > <span>加盟人资质筛选与审核</span> > <span>缴纳费用</span> > <span>签订加盟协议</span> > <span>网点选址、装修验收</span> > <span>办理营业执照</span> > <span>培训学习</span> > <span>提交新开点工作流</span> > <span>开业前准备</span> > <span>开业</span></p> -->
                    <div
                        class="content"
                        v-html="articleContent.osArticleContent.content"
                    ></div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { queryarticlebyid } from "@/api/apiall";
export default {
    data() {
        return {
            category: "",
            articleContent: {}
        };
    },
    created() {
        this.category = this.$route.query.id;
        this.aueryfindbytype();
    },
    methods: {
        aueryfindbytype() {
            queryarticlebyid({ categoryId: this.category, platform: "1" }).then(
                res => {
                    if (res.status == 2000) {
                        this.articleContent = res.data;
                    }
                }
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.franchise {
    padding-bottom: 59px;
    padding-top: 30px;
    background-color: #fff;
    .main {
        .el-col {
            // border: 1px solid #ccc;
            .content {
                white-space: pre-line;
                word-wrap: break-word;
                word-break: break-all;
                // margin-left: 60px;
                p {
                    font-size: 14px;
                    color: #666;
                    margin-top: 16px;
                    line-height: 24px;
                }
                p:nth-child(1),
                p:nth-child(9),
                p:nth-child(16),
                p:nth-child(24) {
                    font-size: 18px;
                    margin-top: 30px;
                    font-weight: 600;
                    color: #000;
                }
                p:nth-child(3),
                p:nth-child(5),
                p:nth-child(18),
                p:nth-child(20),
                p:nth-child(22) {
                    font-weight: 600;
                    color: #333;
                }
                p:nth-last-child(1) {
                    // margin-bottom: 40px;
                    font-size: 15px;
                    color: #333;
                    font-weight: 550;
                }
                .yellow {
                    display: inline-block;
                    width: 36px;
                    height: 3px;
                    background-color: #fabe00;
                }
                .step {
                    span:nth-child(1) {
                        margin-left: -20px;
                    }
                    span {
                        padding: 0 20px;
                    }
                }
            }
        }
    }
}
</style>
